import { Button, Space, Table, Tag, Typography } from 'antd';

const { Paragraph, Text } = Typography;

/* Bascule d'année : vide les classes de l'année précédente et resynchronise depuis Edifice. */
const TransitionPanel = ({ askConfirm, job, launch, platforms, running, selected, setSelected, simulationOk }) => {
  const expectedConfirm = [...selected].sort().join(',');

  const columns = [
    {
      dataIndex: 'projet',
      key: 'projet',
      render: (projet, row) => (
        <Space>
          <Text strong>{projet}</Text>
          {row.exclue && <Tag color="red">exclue</Tag>}
        </Space>
      ),
      title: 'Plateforme',
    },
    { dataIndex: 'etablissements', key: 'etablissements', title: 'Établissements' },
    { dataIndex: 'classes', key: 'classes', title: 'Classes' },
    { dataIndex: 'rentree', key: 'rentree', title: 'Rentrée' },
  ];

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Paragraph type="secondary">
        Supprime les données de l&apos;année précédente (classes, élèves, parents, assignations) sur les plateformes sélectionnées,
        puis resynchronise depuis Edifice les enseignants qui ont déjà utilisé Nabook cette année : eux sont conservés et leurs
        classes remises à jour. Les écritures Edifice sont suspendues pendant l&apos;exécution : à lancer de préférence en heure
        creuse.
      </Paragraph>

      <Table
        columns={columns}
        dataSource={platforms}
        pagination={false}
        rowKey="projet"
        size="small"
        rowSelection={{
          getCheckboxProps: row => ({ disabled: row.exclue || running }),
          onChange: keys => setSelected(keys),
          selectedRowKeys: selected,
        }}
      />

      <Space>
        <Button disabled={selected.length === 0 || running} loading={running && job.dryRun} onClick={() => launch(true)}>
          Simuler
        </Button>
        <Button
          danger
          type="primary"
          disabled={!simulationOk || running}
          loading={running && !job.dryRun}
          onClick={() =>
            askConfirm({
              description: `Cette opération supprime définitivement les données de l'année précédente sur ${selected.join(
                ', ',
              )}. Une sauvegarde de la base est recommandée avant de continuer.`,
              expected: expectedConfirm,
              kind: 'transition',
              title: "Confirmer la transition d'année",
            })
          }>
          Exécuter la transition
        </Button>
        {!simulationOk && selected.length > 0 && <Text type="secondary">Lancer d&apos;abord une simulation.</Text>}
      </Space>
    </Space>
  );
};

export default TransitionPanel;
